"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var PageManager_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageManager = void 0;
const typedi_1 = require("typedi");
const emitter_1 = require("@event/services/emitter");
const type_1 = require("@event/type");
/**
 * Менеджер страницы
 */
let PageManager = PageManager_1 = class PageManager {
    /**
     * Конструктор
     */
    constructor() {
        /**
         * Действие после аутентификации пользователя
         */
        this.actionAfterAuthenticated = this.redirectToPersonalPage;
        this.eventEmitter = typedi_1.Container.get(emitter_1.EventEmitter);
        this.handleUserAuthenticated = this.handleUserAuthenticated.bind(this);
        this.initialize();
    }
    /**
     * Проверяет идентичность действия
     */
    checkActionAfterAuthenticated(callback) {
        return this.actionAfterAuthenticated === callback;
    }
    /**
     * Устанавливает действие после аутентификации пользователя
     */
    doAfterUserAuthenticated(callback) {
        this.actionAfterAuthenticated = callback;
    }
    /**
     * Открывает страницу ЛК
     */
    redirectToPersonalPage() {
        location.href = PageManager_1.ACCOUNT_HREF;
    }
    /**
     * Перезагружает страницу
     */
    reloadPage() {
        location.reload();
    }
    /**
     * Ничего не делает
     */
    doNothing() {
        return;
    }
    /**
     * Инициализирует состояние
     */
    initialize() {
        this.eventEmitter.on(type_1.EventType.USER_AUTHENTICATED, this.handleUserAuthenticated);
    }
    /**
     * Обрабатывает аутентификацию пользователя
     */
    handleUserAuthenticated(data) {
        if (data) {
            this.actionAfterAuthenticated = () => {
                location.href = data;
            };
        }
        this.actionAfterAuthenticated();
    }
};
/**
 * Путь в ЛК
 */
PageManager.ACCOUNT_HREF = '/a/page/account';
PageManager = PageManager_1 = __decorate([
    (0, typedi_1.Service)(),
    __metadata("design:paramtypes", [])
], PageManager);
exports.PageManager = PageManager;
